if (!customElements.get('product-add-to-cart-sticky')) {
class ProductAddToCartSticky extends HTMLElement {
    constructor() {
        super();
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.sectionId = this.dataset.section;
        this.isVisible = false;
    }

    connectedCallback() {
        // Portal to <body> so position:fixed is relative to the viewport, not a transformed
        // ancestor. Many themes apply transform/will-change/contain to product page parents,
        // which silently breaks position:fixed and causes the bar to anchor to the parent
        // bounds instead of the visible viewport (the "bar floats too high when the browser
        // toolbar retracts" symptom). connectedCallback re-fires after the move, so we guard
        // with a flag to avoid an infinite loop.
        if (!this._portaled) {
            this._portaled = true;
            if (this.parentElement !== document.body) {
                document.body.appendChild(this);
                return; // connectedCallback will run again after re-attachment
            }
        }

        this.buyButtonArea = document.querySelector('product-form.product-form:not(.sticky-atc)');
        this.stickyAtcVariantInput = this.querySelector('.sticky-variant-id');
        this.stickyPrice = this.querySelector('.sticky-atc-price');
        this.stickyButton = this.querySelector('.sticky-atc-button');
        this.mainButton = document.querySelector('[id^="ProductSubmitButton-"]');

        if (this.buyButtonArea) {
            this.intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.hide();
                    } else {
                        this.show();
                    }
                });
            }, { threshold: 0 });
            this.intersectionObserver.observe(this.buyButtonArea);
        }

        // Watch the main button for attribute/text changes to stay in sync
        if (this.mainButton) {
            this.buttonObserver = new MutationObserver(() => this.syncFromMainButton());
            this.buttonObserver.observe(this.mainButton, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });
        }

        // Sync variant ID from the main form's hidden input
        this.mainVariantInput = document.querySelector(`#product-form-${this.sectionId} input[name="id"]`);
        if (this.mainVariantInput) {
            this.syncVariantId = () => {
                if (this.stickyAtcVariantInput) {
                    this.stickyAtcVariantInput.value = this.mainVariantInput.value;
                }
            };
            this.mainVariantInput.addEventListener('change', this.syncVariantId);
        }

        document.body.addEventListener('change', this.handleVariantChange);
    }

    disconnectedCallback() {
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.mainVariantInput && this.syncVariantId) this.mainVariantInput.removeEventListener('change', this.syncVariantId);
        document.body.removeEventListener('change', this.handleVariantChange);
    }

    syncFromMainButton() {
        if (!this.mainButton || !this.stickyButton) return;

        this.stickyButton.disabled = this.mainButton.disabled;

        const mainLabel = this.mainButton.querySelector('span:first-child');
        const stickyLabel = this.stickyButton.querySelector('.sticky-atc-label');
        if (mainLabel && stickyLabel) {
            stickyLabel.textContent = mainLabel.textContent.trim();
        }

        const mainPriceEl = this.mainButton.querySelector('.btn_final_price');
        if (mainPriceEl && this.stickyPrice) {
            this.stickyPrice.innerHTML = mainPriceEl.innerHTML;
        }
    }

    show() {
        if (this.isVisible) return;
        this.isVisible = true;
        this.classList.add('show');
    }

    hide() {
        if (!this.isVisible) return;
        this.isVisible = false;
        this.classList.remove('show');
    }

    updateStickyATCOption(optionName, optionValue) {
        const matches = optionName.match(/options\[(.+)\]/);
        if (matches && matches[1]) {
            optionName = matches[1];
        }

        const optionDisplay = this.querySelector('.selected-variant-option[data-option-name="' + optionName + '"]');
        if (optionDisplay) {
            optionDisplay.textContent = optionName + ': ' + optionValue;
        }
    }

    handleVariantChange(event) {
        const target = event.target;
        const productSection = target.closest(`#MainProduct-${this.sectionId}`);
        if (!productSection) return;

        if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
            const optionName = target.name;
            const optionValue = target.tagName === 'INPUT' ? target.value : target.options[target.selectedIndex].textContent;
            this.updateStickyATCOption(optionName, optionValue);
        }

    }
}

customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}
